export enum CustomerType {
  Commercial = 'Commercial',
  Residential = 'Residential',
}
